import { useContext, useEffect, useRef, useState } from 'react';
import { Field, FieldArray, Form, Formik } from 'formik';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { scrollTo } from '../common';
import { Common } from '../common/common';
import { AccountContext } from "../aws-pool/Account";
import * as Constants from '../common/constant';
import { APP_FLOW, config } from '../common/constant';
import { ACCORDION_BOTTOM, ACCORDION_TOP, FIDYAH } from '../common/images-svg';
import { homePageService } from '../jwt/_services/home-page-service';
import * as homepage from '../redux/actions/homepageAction';
import * as userActions from '../redux/actions/userAction';
import { fidyahActions } from '../redux/reducers/fidyah-slice';
import { debounce, isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Footer from '../section/footer/footer';
import { enrollmentMethodHeaderData } from '../section/pay-zakat/type-of-zakat';

const QuickFidyah = ({setHeaderData}) => {
	const context = useContext(AccountContext);
	const dispatch = useDispatch();
    const { t } = useTranslation()
    const history = useHistory()

	const homepageData = useSelector(state => state.homepageReducer);
	const fidyahData = useSelector(state => state.fidyahReducer);
	const user = useSelector(state => state.userReducer);

	const [initialOfFidyah, setInitialOfFidyah] = useState(user.isDeceased === null);
	const [selectedFidyahCalcField, setSelectedFidyahCalcField] = useState('Haid-or-Other-Reason');
	const [isError, setIsError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [fidyahOpen, setFidyahOpen] = useState(true); 
	const makePaymentButtonRef = useRef(null);
	const calcMakePaymentButtonRef = useRef(null);

	const fidyahRate = homepageData.muisZakatFidyah?.fidyahPerDay || 0;

	useEffect(() => {
		sessionStorage.setItem("flowType", APP_FLOW.FIDYAH);
		const menuSection = document.querySelector('.c-pay-fidyah-calculator .c-pay-fidyah');
		const btnScroll = document.querySelector('.c-pay-fidyah-calculator .btn-scroll-up');
		const ttlPayable = document.querySelector('.c-pay-fidyah-calculator .c-ttl-payment');

		const scrollType = history?.location?.state?.type;
		if (scrollType) {
			setSelectedFidyahCalcField(scrollType);
			// setTimeout(() => focusedHandler(scrollType, 'scroll'), 200);
		} else {
			scrollTo();
		}

		dispatch(userActions.updateIRASInclusion(false));

		return () => {
			// Cleanup scroll handler if needed
		};
	}, []);

	useEffect(() => {
		dispatch(userActions.updatePaymentData({
			...user,
			isAmountChanged: true,
		}));
	}, [fidyahData]);

	const getTotalAmount = () => fidyahData.totalAmount.toFixed(2);

	const shouldMakePaymentEnable = () => {
		const totalAmount = getTotalAmount();
		return fidyahRate <= totalAmount && totalAmount <= Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT;
	};

	const getAmountErrorMessage = () => {
		const totalAmount = getTotalAmount();
		if (!totalAmount || totalAmount <= 0.00001) return null;
		if (totalAmount < fidyahRate) return `${t('Fidyah_min_payment_err')} ${Common.intlNumberFormat(fidyahRate)}`;
		if (totalAmount > Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT) return `${t('Fidyah_max_payment_err')} ${Common.intlNumberFormat(Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT)}`;
		return null;
	};

	const getTransactionNo = (e, amount) => {
		if (!shouldMakePaymentEnable()) {
			e.preventDefault();
			return;
		}

		setIsLoading(true);

		makePaymentButtonRef.current?.setAttribute("disabled", true);
		calcMakePaymentButtonRef.current?.setAttribute("disabled", true);

		const muisFidyah = [];

		if (fidyahData.haidAmount) {
			muisFidyah.push({ amount: Number(parseFloat(fidyahData.haidAmount).toFixed(2)), name: "Haid or Other Reason" });
		}
		if (fidyahData.illnessAmount) {
			const remark = String(fidyahData.illness?.remark).trim();
			muisFidyah.push({ amount: Number(parseFloat(fidyahData.illnessAmount).toFixed(2)), name: "Illness or Old-age", remark: remark ? [remark] : [] });
		}
		if (fidyahData.pregnancyAmount) {
			muisFidyah.push({ amount: Number(parseFloat(fidyahData.pregnancyAmount).toFixed(2)), name: "Pregnancy or Feeding" });
		}

		const payload = {
			charityId: Constants.config.MUIS_CHARITY_ID,
			amount: String(parseFloat(amount).toFixed(2)),
			currency: homepageData.currencyCode ?? 'SGD',
			hasIRASInclusion: false,
			isDeceased: user.isDeceased !== null ? user.isDeceased : false,
			donationType: parseInt(homepageData.muisZakatFidyah.id),
			attribute: JSON.stringify({ muisFidyah }),
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			transactionNumber: user.transactionNo ?? null,
		};

		// Call payment API here if needed
	};

	const handleValueChange = (field, amount, setValues, values) => {
		const parsedAmount = parseFloat(amount) || 0;
		if (parsedAmount <= Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT) {
			setValues({ ...values, [field]: parsedAmount });
			switch (field) {
				case 'haid':
					dispatch(fidyahActions.updateHaidAmount(parsedAmount));
					break;
				case 'illness':
					dispatch(fidyahActions.updateIllnessAmount(parsedAmount));
					break;
				case 'pregnancy':
					dispatch(fidyahActions.updatePregnancyAmount(parsedAmount));
					break;
			}
		}
	};

	const initialValues = {
		haid: fidyahData.haidAmount || '',
		illness: fidyahData.illnessAmount || '',
		pregnancy: fidyahData.pregnancyAmount || '',
	};
	const toggleAccordion = () => {
		setFidyahOpen((prev) => !prev);
	  };

    const handleNext = () => {
        setHeaderData(enrollmentMethodHeaderData)
        dispatch(userActions.updateUserSteps(enrollmentMethodHeaderData))
        


    }
    const handleSkip = () => {

    }

    

	return (
        <>
        <div className='flow-view'>
		<div className={`landing-page c-calc-page ${homepageData.lang || ''}`}>
			<div className='sec-container'>
				<div className='c-pay-fidyah-calculator c-calculator'>
					<div className='c-body'>
						<div className={`c-pay-fidyah ${fidyahOpen ? "open" : ""}`}>
							<div className='accordion-button' 
							// onClick={toggleAccordion}
							>
								<h3 className='title'> Fidyah - <span>${getTotalAmount()}</span> </h3>
								{/* <button className='btn btn-transparent'>{fidyahOpen ? <> {ACCORDION_TOP}</>  : <>{ACCORDION_BOTTOM} </> }</button> */}
							</div>
							<div className="accordion-content">
								<Formik
									initialValues={initialValues}
									enableReinitialize
									validateOnMount
									validateOnBlur
									validateOnChange
									validate={() => setIsError(!!getAmountErrorMessage())}
								>
									{({ values, setValues }) => (
										<Form className='form'>
											{['haid', 'illness', 'pregnancy'].map((field, index) => (
												<div key={field} className={`sc ${selectedFidyahCalcField === field ? 'active' : ''}`}>
													<div className='row d-flex align-center'>
														<div className='col-md-6 col-sm-6 col-xs-6'>
															<div className='c-label'>
																<label htmlFor={field} dangerouslySetInnerHTML={{ __html: t(`Fidyah_${field}`) }}></label>
															</div>
														</div>
														<div className='col-md-6 col-sm-6 col-xs-6'>
															<div className='form-group mb-0'>
																<NumberFormat
																    inputMode="decimal"
																	type='text'
																	id={field}
																	name={field}
																	placeholder="$0.00"
																	prefix="$"
																	decimalSeparator='.'
																	thousandSeparator
																	allowLeadingZeros={false}
																	decimalScale={2}
																	className="form-control"
																	value={values[field] || ''}
																	allowNegative={false}
																	isAllowed={({ floatValue }) =>
																		floatValue === undefined ||
																		floatValue <= Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT
																	}
																	onValueChange={(val, sourceInfo) => {
																		if (sourceInfo.event) {
																			handleValueChange(field, val.floatValue, setValues, values);
																		}
																	}}
																/>
															</div>
														</div>
													</div> 
												</div>
											))}
											{/* <div className='btm-line'></div> */}
											{/* <div className='c-ttl-payment'>
												<div className='c-ttl'>
													<span className='lbl'>{t('Fidyah_total_payable')}</span>
													<span className='amt'>{Common.intlNumberFormat(getTotalAmount())}</span>
												</div>
												<button
													ref={makePaymentButtonRef}
													type="button"
													className='btn btn-dark btn-pay-now'
													disabled={!shouldMakePaymentEnable()}
													onClick={(e) => getTransactionNo(e, getTotalAmount())}
												>
													{t('Fidyah_make_payment')}
												</button>
											</div> */}
											{isError && <span className="invalid-feedback error">{getAmountErrorMessage()}</span>}
										</Form>
									)}
								</Formik>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </div>
        <Footer setHeaderData={setHeaderData} isSkipButtonVisible={false} handleNext={handleNext} handleSkip={handleSkip} disabled={!shouldMakePaymentEnable()} totalPayable={Common.intlNumberFormat(getTotalAmount())}  />
        </>
	);
};

export default withTranslation()(QuickFidyah);